export const blockIconsMapsLocalFireDepartmentNew = (
	<span className='material-symbols-outlined'>local_fire_department</span>
);
